/**
 * Google AdSense 自定义搜索广告（AFS / CSA）脚本地址
 */
export const AFS_SCRIPT_URL = 'https://www.google.com/adsense/search/ads.js';

/**
 * AFS 发布商配置
 * 当前仅用于"保活资质"：产生广告请求以维持 AdSense 账号活跃状态
 */
export const AFS_CONFIG = {
  /** 发布商 ID */
  PUB_ID: 'partner-pub-5347174516153403',
  /** 自定义搜索样式 ID */
  STYLE_ID: '4205544768',
} as const;
